module.exports = __webpack_public_path__ + "img/fond_pave_employeur.22838fe.png";